// ApprovalConfirmationModal.js - Simplified loading state
import React from "react";
import "../styles/ApprovalConfirmationModal.css";

const ApprovalConfirmationModal = ({
  onClose,
  onConfirm,
  reportTitle,
  isLoading,
}) => {
  return (
    <div
      className="approval-modal-backdrop"
      onClick={isLoading ? null : onClose}
    >
      <div
        className="approval-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="approval-modal-header">
          <h3>Approve Report</h3>
          {!isLoading && (
            <button className="approval-modal-close-btn" onClick={onClose}>
              &times;
            </button>
          )}
        </div>
        <div className="approval-modal-body">
          <div className="approval-modal-icon">
            <i className="fas fa-lock"></i>
          </div>
          <h4>Are you sure you want to approve "{reportTitle}"?</h4>

          <div className="approval-info-panel">
            <p className="approval-info-title">
              <i className="fas fa-info-circle"></i> What happens after
              approval:
            </p>
            <ul className="approval-info-list">
              <li>
                The report will be <strong>locked for audit compliance</strong>
              </li>
              <li>No further changes can be made to the approved data</li>
              <li>You will still be able to view the report at any time</li>
              <li>Notes can still be added for additional context</li>
            </ul>
            <p className="approval-info-note">
              <i className="fas fa-exclamation-circle"></i> This action cannot
              be undone. To make changes after approval, you will need to create
              a new version of the report.
            </p>
          </div>
        </div>
        <div className="approval-modal-actions">
          <button
            className="approval-modal-cancel"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className="approval-modal-confirm"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="button-loading">
                <i
                  className="fas fa-spinner fa-spin"
                  style={{ marginRight: "8px" }}
                ></i>
                Creating Approved Copy...
              </span>
            ) : (
              "Approve & Lock Report"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApprovalConfirmationModal;
